import { Row, Col, Icon } from 'antd';

export default class Pending extends React.Component {
    constructor(props) { super(props); }
    render() {
        return (
            <div className='afsp-login-indicator-status-error'>
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    <br></br>
                    <br></br>
                    <Icon type='exclamation-circle-o' style={{ fontSize: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                        {'E-mail sent to your e-mail address on file.'}
                    </span>
                    <br></br>
                    <br></br>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <div style={{ fontStyle: 'italic', lineHeight: '14px' }}>
                                {'Please check your e-mail for your account reactivation link.'}<br></br><br></br>
                            </div>
                        </Col>
                    </Row>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <div style={{ fontStyle: 'italic', lineHeight: '14px' }}>
                                {'For further assistance, please contact FTSP Help:'}
                                <div style={{ marginTop: '5px' }}>
                                    <span style={{ fontWeight: 'bold' }}>
                                        <a href='mailto:FTSP.Help@tsa.dhs.gov'>
                                            {'FTSP.Help@tsa.dhs.gov'}
                                        </a>
                                    </span>
                                    {'.'}
                                </div>
                            </div>
                        </Col>
                    </Row>

                </div>
            </div>
        );
    }
}